import { Component, Input, OnInit, OnChanges, AfterViewInit} from "@angular/core";
import { FormGroup } from "@angular/forms";

import {InsaCronService} from "../../../../../insa-services";
import {InterfaceJobDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-interface-details",
    template: require("./edit-interface-details.component.html")
})
export class EditInterfaceDetailsComponent implements OnInit, AfterViewInit{
   _activityID:any;
   @Input() set interfaceDetails(activityData: any) {this._activityID = activityData;}; 
   
   interfaceDetailsData:InterfaceJobDetails = new InterfaceJobDetails();

   @Input() editInterfaceForm: FormGroup;
   banks: any = []; //Array<ChoronosBanks> = [];

   constructor(private _insaChronosService: InsaCronService){  }

   ngOnInit(){
    this._insaChronosService.getBanks().subscribe((data: any) => {
        this.banks = data;
        //console.log("banks bint comp => " + this.banks);
        //console.log("bankID bint comp => " + this.banks.BankID);
    })
   }
    
   ngAfterViewInit(){
    if(this._activityID!==undefined && this._activityID!==null){
        this._insaChronosService.getInterfaceDetails(this._activityID).subscribe((a: any) => {
            this.interfaceDetailsData = a;
            console.log("bankint bankid => " + this.interfaceDetails.BankID);
        });
     }   
   }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/interface-job-details/edit-interface-details.component.ts